import { log } from 'console';

export const copy = {
  pages: {
    dashboard: {
      title: 'Dashboard',
      description: '',
      totalNumberOfMentees: 'Total Number of Mentees',
      numberOfSessionsConductedThisMonth:
        'Number of Sessions Conducted this Month',
      pendingConnectionRequests: 'Pending Connection Requests',
      earningsSummary: 'Earnings Summary',
      yourRatings: 'Your Ratings',
      tasks: 'Tasks',
      upcomingMentorshipSessions: 'Upcoming Mentorship Sessions',
      resources: 'Resources',
      paidMentees: 'Paid Mentees',
      yourConnectedMenteesHaveNotYetPurchasedAnyMentoring:
        'Your Connected Mentees - Have not yet Purchased any Mentoring',
      menteeConnectionRequests: 'Mentee Connection Requests',
      mentoringResources: 'Mentoring Resources',
      careerTools: 'Career Tools',
      careerGoals: 'Career Goals',
      pendingMentorshipConnectionRequests:
        'Pending Mentorship Connection Requests',
      recommendedMentors: 'Recommended mentors',
      recommendedGroupMentoringCohorts: 'Recommended Group Mentoring Cohorts',
      completeMentoringProfile: 'Complete Mentoring Profile',
      completeProfessionalProfile: 'Complete Professional Profile',
      completeMentorshipPreferences: 'Complete Mentorship Preferences',
      completed: 'Completed',
      inProgress: 'In Progress',
      completeTask: 'Complete Task',
      createYourAvailabilitySchedule: 'Create Your Availability Schedule',
      createYourMentoringPackages: 'Create Your Mentoring Packages',
      addYourProfilePicture: 'Add Your Profile Picture',
      completeYourPersonalInformation: 'Complete Your Personal Information',
      profileSuccessfullyCreated: 'Profile successfully created',
      profileSuccessfullyCreatedDescription:
        'Your profile has been successfully created. You must login again to continue.',
      profileSuccessfullyCreatedForMentorDescription:
        'Your profile has been successfully created. We will review the information you provided and and get back to you as soon as we can. We appreciate your patience during this process.',
      weAreStillWorkingOnYourApplication:
        'We are still working on your application',
      weAreStillWorkingOnYourApplicationDescription:
        'Your mentor application is pending approval. Please wait for confirmation until we review your application.',
      mentorPendingApprovalMessage:
        'Your application to become a mentor is currently under review. We appreciate your patience during this process and will notify you once a decision has been made.',
      clickToLogOut: 'Click to log out',
      createYourProfile: 'Create Your Profile',
      createYourProfileDescription:
        'Please complete your profile to access all features.',
      createYourProfileDescriptionParagraph:
        'Now you must create your profile as mentor or mentee to start connecting with mentors and mentees and book mentoring sessions.',
      applyToBecomeAMentor: 'Apply to Become a Mentor',
      createMenteeProfile: 'Create Mentee Profile',
      createYourProfileWarningMessage:
        "Once you create proceed in applying to become a mentor or creating your mentee profile, you won't be able to change your account type. Please make sure to choose the right account type for you.",
      logoutInfo:
        'Have another account or want to leave this page? Click the button below to log out and return to the login page.',
    },
    notFound: {
      comingSoon: 'Coming Soon',
      backToDashboard: 'Back to Dashboard',
      pageNotFound: 'Page Not Found',
      pageNotFoundDescription:
        'The page you are looking for could not be found or has been moved.',
      finishSessionDescription:
        'If you were redirected to this page again. Try to finish your session and login again.',
      finishSession: 'Finish Session',
    },
    signin: {
      title: 'Sign In',
      description: '',
      ctaContent: {
        title: (
          <>
            <strong>Start your</strong> Journey with us.
          </>
        ),
      },
    },
    root: {
      welcome: 'Welcome to The Black Women in Tech Hub',
      createAnAccountAsMentor: 'Create an account as Mentor',
      createAnAccountAsMentee: 'Create an account as Mentee',
      createAnAccount: 'Create an account',
      login: 'Login',
      requestingLogin: 'Requesting Login...',
    },
    signup: {
      title: 'Personal Information',
      description: '',
      ctaContent: {
        title: 'Create Your Account',
      },
      dataDisclaimer:
        'Your data is secure with us – we prioritize your privacy and never share your information without consent.',

      mentor: {
        title: 'Application to be Mentor',
        mentorshipType: 'Mentorship Type',
        estimatedPricePerSession: 'Estimated Price Per Session',
        finalRatesMightBeNegotiated: 'Final Rates Might Be Negotiated.',
        maximumNumberOfOneOnOneSessionsYear:
          'Maximum Number Of 1:1 Sessions/Year',
        maximumNumberOfGroupSessionsYear:
          'Maximum Number Of Group Sessions/Year',
        preferredSessionDuration:
          'Preferred Session Duration (30mins/45mins/60mins)',
        availableForChatMicroMentoring: 'Available For Chat Micro Mentoring',
        maxNumberOfChatForOneOnOneMenteesYear:
          'Max Number Of Chat For 1:1 Mentees/Year',
        idCheck: 'Id Check',
        uploadId: 'Upload Id',
        iHaveFormalMentoringOrCoachingTraining:
          'I have formal Mentoring or Coaching Training',
        yearsOfMentoringExperience: 'Years of Mentoring Experience',
        yearsOfExperience: 'Years of Experience',
        whyDoYouWantToBeAMentor: 'Why do you want to be a Mentor',
        mentoringSkills: 'Mentoring Skills',
        applicationSubmittedSuccessfully: 'Application Submitted Successfully',
        confirmationMessage:
          'Your application has been received and will be reviewed in the next few days. If needed a meeting will be scheduled with you to validate your Id. discuss your mentoring experience and discuss your mentoring fees.',
        clickToConfirmYourEmail:
          'We sent a code to your email. Click here to confirm',
        toFollowUpOnYourApplication: 'to follow up on your application',
      },
    },
    verify: {
      title: 'Verify Your Email',
      description: 'We have sent a code to',
      didNotReceiveCode: 'Did not receive code?',
      resendCode: 'Resend code',
    },
    profile: {
      personalInformation: 'Personal Information',
      mentoringContractWithBWBN: 'Mentoring Contract with BWBN',
      personalInformationUpdated: 'Your personal information has been updated',
      errorUpdatingPersonalInformation:
        'An error happened while updating your personal information',
      mentorshipPreferences: 'Mentorship Preferences',
      mentorshipPreferenceUpdated:
        'Your mentorship preferences has been updated',
      techSectorFocus: 'Tech Sector Focus',
      areaOfExpertiseSkills: 'Area of Expertise/Skills',
      preferredMenteeCareerStageFocus: 'Preferred Mentee - Career Stage/Focus',
      offeredMentoringModelsAndTypes: 'Offered Mentoring Models and Types',
      mentoringModelsAndTypes: 'Mentoring Models and Types',
      mentoringLanguages: 'Mentoring Languages',
      yourMentorshipPhilosophy: 'Your Mentorship Philosophy',
      bio: 'Bio',
      professionalBackground: 'Professional Background',
      currentEmploymentStatus: 'Current employment Status',
      currentOccupation: 'Current Occupation',
      currentIndustry: 'Current Industry',
      certifications: 'Certifications',
      yearsOfExperience: 'years of experience',
      skillsYouCurrentlyHave: 'Skills you currently have',
      otherSkills: 'Other Skills',
      linkedInProfileLink: 'LinkedIn Profile Link',
      availability: 'Availability',
      mentoringAgreements: 'Mentoring Agreements',
      paymentDetails: 'Payment Details',
      bankName: 'Bank Name',
      bankAccountNumber: 'Bank Account Number',
      accountName: 'Account Name',
      branchAddress: 'Branch Address',
      routingNumber: 'Routing Number',
      paymentHistory: 'Payment History',
      paymentInvoice: 'Payment Invoice',
      amount: 'Amount',
      date: 'Date',
      status: 'Status',
      uploadTheSignedContract: 'upload the signed contract',
      downloadTheContract: 'download the contract',
      startTime: 'Start Time',
      endTime: 'End Time',
      selectStartTime: 'Select Start Time',
      selectEndTime: 'Select End Time',
      meetingSettings: 'Meeting Settings',
      mentoringFocus: 'Mentoring Focus',
      preferredMentorsSkills: 'Preferred Mentors Skills',
      interestedMentoringModelsAndPrograms:
        'Interested Mentoring Models and Programs',
      yourCurrentCareerGoals: 'Your Current Career Goals',
      aboutMe: 'About me',
      cv: 'CV',
      uploadCv: 'Upload Cv',
      uploadNewCv: 'Upload New Cv',
      subscription: 'Subscription',
      subscriptionPlan: 'Subscription plan',
      completedMentoringProgram: 'Completed mentoring program',
      warningMessageDeleteCV:
        'This will permanently delete your CV and remove your data from our servers. You can upload a new one by choosing a new PDF file in the CV page.',
      loadingCV: 'Loading CV',
      youDoNotHaveACV:
        "You don't have a CV. Use the field below do upload yours.",
      yourCVHasBeenUploaded: 'Your CV has been uploaded',
      meetingLink: 'Meeting Link',
      meetingSlotTime: 'Meeting Slot Time ( In Minutes )',
      yourAvailabilitySchedule: 'Your Availability Schedule',
      menteeDetails: 'Mentee Details',
      mentorProfile: 'Mentor Profile',
      profileNotFoundOrNoLongerExists: 'Profile not found or no longer exists.',
      careerGoals: 'Career Goals',
      preferredMentorshipProgram: 'Preferred Mentorship Program',
      notInformed: 'Not Informed',
      mentorshipModels: 'Mentorship Models',
      whatMenteesSay: 'What Mentees Say',
      similarMentors: 'Similar Mentors',
      industryExperience: 'Industry Experience',
      skills: 'Skills',
      mentorshipFocus: 'Mentorship Focus',
      mentoringSessions: 'Mentoring Sessions',
      remainingSessions: 'Remaining Sessions',
      completedSessions: 'Completed Sessions',
      upcomingSessions: 'Upcoming Sessions',
      timesShownIn: 'Times shown in',
      unavailable: 'Unavailable',
      estimatedPricePerSession: 'Estimated Price Per Session',
    },
    searchMentors: {
      recommendedMentors: 'Recommended Mentors',
      noMentorsSearchResult:
        'No mentor has been found. Please refine your search and try again',
      mentoringFeesStartingFrom: 'Mentoring Fees Starting From',
      freeIntroCall: 'Free Intro Call',
      oneOnOnementorFee: '1:1 Mentor Fee',
      session: '/session',
      emptyFilter: 'Empty Filter',
      emptyFilterMessage: 'You must select at least one item in the filter.',
      useFiltersToSearchForMentors: 'Use the filters to search for mentors.',
      free: 'Free',
    },
    searchMentees: {
      preferences: 'Preferences',
      mentorshipModels: 'Mentorship Models',
      mentorshipFocus: 'Mentorship Focus',
      name: 'Name',
      useFiltersToSearchForMentees: 'Use the filters to search for mentees.',
    },
    mentorProfile: {
      pageTitle: 'Mentor Profile',
    },
    menteeProfile: {
      interestedMentoringModels: 'Interested Mentoring Models',
      note: 'Note:',
    },
    mentoringPackages: {
      title: 'Mentoring Package',
      mentoringPackages: 'Mentoring Packages',
      createMentoringPackage: 'Create Mentoring Package',
      packageType: 'Package Type',
      displayName: 'Display Name',
      displayNamePlaceholder: 'Enter package name',
      description: 'Description',
      descriptionPlaceholder: 'Describe your mentoring package',
      outcomes: 'Outcomes',
      outcomesPlaceholder: 'What outcomes can mentees expect?',
      freeIntroCall: 'Free Intro Call',
      numberOfSessions: 'Number of Sessions',
      sessionDuration: 'Session Duration',
      price: 'Price',
      packageCreated: 'Package Created',
      packageCreatedDescription:
        'Your mentoring package has been created successfully.',
      packageUpdated: 'Package Updated',
      packageUpdatedDescription:
        'Your mentoring package has been updated successfully.',
      coverImage: 'Cover Image',
      pricePerSession: 'Price Per Session',
      packagePrice: 'Package Price',
      sessions: 'Sessions',
      session: 'Session',
      activePackages: 'Active Packages',
      inactivePackages: 'Inactive Packages',
      editPackage: 'Edit Package',
      createNewPackage: 'Create New Package',
      status: 'Status',
      statusDescription:
        'ATTENTION: Status are active by default upon creation and will be visible to mentees. By choosing a different status, you can control the visibility of your package. Inactive packages will not be shown to mentees. Archived packages will be hidden from all users.',
      purchasePackage: 'Purchase Package',
      buyAgain: 'Purchase More Sessions',
      packageDetails: 'Package Details',
      paymentSuccessful: 'Payment Successful',
      packagePurchaseSuccess:
        'You have successfully purchased the mentoring package. You can now schedule your sessions with the mentor.',
      pay: 'Pay',
      processing: 'Processing...',
      loading: 'Loading...',
      totalSessions: 'Total Sessions',
      minutes: 'minutes',
      hasFreeIntroCall: 'Has Free Intro Call',
      packageDetailsAndOutcomes: 'Package Details and Outcomes:',
      sessionCancellationAndReschedulingPolicy:
        'Session Cancellation and Rescheduling Policy',
      hostedBy: 'Hosted by: ',
      bookASession: 'Book a Session',
      bookASessionDescription:
        'Schedule a one-on-one session with your mentor at a time that works for you.',
      viewAvailabilityCalendar: 'View Availability Calendar',
      availabilityCalendar: 'Availability Calendar',
      youCanSelect: 'You can select',
      selectedSessions: 'Selected Sessions',
      remove: 'Remove',
      moreSessions: 'more session(s)',
      maximumSessionsSelected: 'Maximum sessions selected',
      availabilityCalendarDescription:
        'View the mentor’s available time slots to schedule your sessions conveniently.',
      sessionsBookedSuccessfully: 'Sessions booked successfully',
      mentorshipSessionScheduled: 'mentorship session(s) have been scheduled.',
      startTime: 'Start Time',
      endTime: 'End Time',
      viewPackageDetails: 'View Package Details',
      goToTheMeetingRoom: 'Go to the Meeting Room',
      mentor: 'Mentor',
      mentee: 'Mentee',
      mentorshipPackageTermsAndConditions: {
        title: 'Mentorship Package Terms and Conditions:',
        introduction:
          'By purchasing or offering a Mentorship Package on the Black Women in Tech Hub (BWTH) platform, you agree to the following:',
        packageDetails: {
          title: 'Package Details',
          content:
            'Each package includes a set number of sessions, duration, and format (one-on-one or group). Packages are non-transferable and expire if unused within the defined period.',
        },
        scheduling: {
          title: 'Scheduling',
          content:
            "Mentees must book sessions according to the Mentor's availability. Group sessions have fixed schedules. Missed sessions without 24-hour notice may be forfeited.",
        },
        paymentsAndFees: {
          title: 'Payments & Fees',
          content:
            'Payments are handled securely through Stripe. BWTH collects a small service fee. Mentors receive payouts after sessions are completed.',
        },
        refunds: {
          title: 'Refunds',
          introduction: 'Refunds are only allowed if:',
          items: [
            'The Mentor cancels before sessions start, or',
            'The Mentee requests a refund within 48 hours of purchase (no sessions held).',
            'Group sessions are non-refundable once started.',
          ],
        },
        responsibilities: {
          title: 'Responsibilities',
          items: [
            'Mentors must provide professional, respectful, and honest mentorship.',
            'Mentees must attend on time, act respectfully, and use the program for learning purposes only.',
            'Confidentiality must be respected by both parties.',
          ],
        },
        intellectualProperty: {
          title: 'Intellectual Property',
          content:
            'All materials shared by Mentors remain their property and may not be copied or resold.',
        },
        platformRole: {
          title: 'Platform Role',
          content:
            'BWTH connects Mentors and Mentees but is not responsible for mentorship outcomes or advice quality. Mentors act as independent contractors.',
        },
        privacy: {
          title: 'Privacy',
          content: 'Personal data is handled per our Privacy Policy.',
        },
        terminationAndUpdates: {
          title: 'Termination & Updates',
          content:
            'BWTH may suspend accounts violating these terms. Terms may be updated at any time.',
        },
      },
    },
    groupCohorts: {
      title: 'Group Cohort',
      groupCohorts: 'Group Mentoring Cohorts',
      createGroupCohort: 'Create Group Cohort',
      displayName: 'Display Name',
      displayNamePlaceholder: 'Enter cohort name',
      description: 'Description',
      descriptionPlaceholder: 'Describe your group mentoring cohort',
      startDate: 'Start Date',
      startDatePlaceholder: 'Select start date',
      numberOfSessions: 'Number of Sessions',
      frequency: 'Frequency',
      sessionDuration: 'Session Duration',
      pricePerParticipant: 'Price Per Participant',
      maxParticipants: 'Maximum Participants',
      cohortCreated: 'Cohort Created',
      cohortCreatedDescription:
        'Your group cohort has been created successfully.',
      cohortUpdated: 'Cohort Updated',
      cohortUpdatedDescription:
        'Your group cohort has been updated successfully.',
      coverImage: 'Cover Image',
      sessions: 'Sessions',
      session: 'Session',
      activeCohorts: 'Active Cohorts',
      inactiveCohorts: 'Inactive Cohorts',
      editCohort: 'Edit Cohort',
      createNewCohort: 'Create New Cohort',
      status: 'Status',
      statusDescription:
        'ATTENTION: Cohorts are active by default upon creation and will be visible to mentees. By choosing a different status, you can control the visibility of your cohort. Inactive cohorts will not be shown to mentees. Archived cohorts will be hidden from all users.',
      participants: 'Participants',
      cohortDetails: 'Cohort Details',
      minutes: 'minutes',
      enrollNow: 'Enroll Now',
      alreadyEnrolled: 'Already Enrolled',
      enrollmentSuccessful: 'Enrollment Successful',
      cohortEnrollmentSuccess:
        'You have successfully enrolled in the group cohort.',
      searchCohorts: 'Search Group Cohorts',
      upcomingCohorts: 'Upcoming Cohorts',
      joinedCohorts: 'Joined Cohorts',
      completedCohorts: 'Completed Cohorts',
      enrollClosed: 'Enrollment Has Been Closed',
      scheduleSessions: 'Schedule Sessions',
      addSession: 'Add Session',
      scheduleSessionsDescription: 'Schedule group cohort sessions',
      noSessionsAdded: 'No sessions added yet',
      clickAddSession: 'Click "Add Session" to schedule a session',
      sessionDateTime: 'Session Date & Time',
      duration: 'Duration',
      sessionsScheduled: 'Sessions Scheduled',
      numberOfAttendees: 'Number of Attendees',
      viewCohortDetails: 'View Cohort Details',
    },
    meetingRoom: {
      title: 'Meeting Room',
      hostedBy: 'Hosted by',
      to: 'to',
      callEnded: 'Call ended',
      rejoinCall: 'Rejoin call',
      markSessionAsComplete: 'Mark Session as Complete',
      markingAsComplete: 'Marking as Complete...',
      sessionMarkedComplete: 'Session Marked as Complete',
      sessionAlreadyCompleted: 'Session Completed',
      confirmSessionCompletionTitle: 'Confirm Session Completion',
      confirmSessionCompletionDescription:
        'Are you sure you want to mark this session as complete? This action cannot be undone.',
      confirmButton: 'Mark as Complete',
      cancelButton: 'Cancel',
      sessionHasBeenCompleted: 'Session has been marked as completed',
      sessionHasBeenCompletedDescription:
        'This session is now marked as completed by the mentor.',
    },
    contactUs: {
      title: 'Email Support',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      subject: 'Subject',
      details: 'Details',
      detailsPlaceholder: 'Write in details about the issue you are facing',
      attachment: 'Attachment',
      supportRequestHasBeenSent: 'Support Request Has Been Sent',
    },
    mentees: {
      myPaidMentees: 'My Paid Mentees',
      myConnectedMentees: 'My Connected Mentees',
      recommendedMentees: 'Recommended Mentees',
      searchMentees: 'Search Mentees',
    },
    reportDispute: {
      title: 'Report Dispute',
      sendReport: 'Send Report',
      sending: 'Sending...',
      subject: 'Subject',
      details: 'Details',
      detailsPlaceholder: 'Write in details about the issue you are facing',
      attachment: 'Attachment',
      supportRequestHasBeenSent: 'Your Report Has Been Sent',
      category: 'Category',
    },
    resetPassword: {
      title: 'Reset Password',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      emailAddress: 'Email Address',
      requestPasswordReset: 'Request Password Reset',
      resetPasswordNow: 'Reset Password Now',
      verificationCode: 'Verification Code',
      verificationCodeDescription:
        'Enter the verification code sent to your email.',
      passwordResetSuccess: 'Password Reset Successful',
      passwordResetSuccessDescription:
        'Your password has been reset successfully. You can now log in with your new password.',
      verificationCodeSent: 'Verification Code Sent',
      verificationCodeSentDescription:
        'A verification code has been sent to your email address. Please check your inbox and enter the code to proceed with resetting your password.',
      tryAgain: 'Try Again',
      doNotWantToReset: 'Do not want to reset your password?',
      backToLogin: 'Back to Login',
    },
    updatePassword: {
      title: 'Update Password',
      updatePasswordButton: 'Update Password',
      updating: 'Updating...',
      updateSuccess: 'Password Updated Successfully',
      updateSuccessDescription: 'Your password has been updated successfully.',
      updateError: 'Error Updating Password',
      updateErrorDescription:
        'There was an error updating your password. Please try again.',
    },
    admin: {
      title: 'Admin',
      dashboard: 'Admin Dashboard',
      welcomeMessage: 'Welcome to the Admin Dashboard',
      overview: 'Platform Overview',
      totalMentors: 'Total Mentors',
      totalMentees: 'Total Mentees',
      viewAll: 'View All',
      manageMentors: 'Manage Mentors',
      reviewAndManageMentorApplications:
        'Review and manage mentor applications',
      pendingApplications: 'Pending Applications',
      pendingApplicationsDescription: 'Applications awaiting review',
      allMentors: 'All Mentors',
      allMentorsDescription: 'Approved and rejected mentor applications',
      noPendingApplications: 'No pending applications',
      noMentorsFound: 'No mentors found',
      manageMentees: 'Manage Mentees',
      viewAndManageMentees: 'View and manage all mentees',
      allMentees: 'All Mentees',
      noMenteesFound: 'No mentees found',
      suspend: 'Suspend',
      activate: 'Activate',
      suspendUser: 'Suspend User',
      activateUser: 'Activate User',
      suspendUserConfirm:
        'Are you sure you want to suspend this user? They will not be able to access the platform until reactivated.',
      activateUserConfirm:
        'Are you sure you want to activate this user? They will be able to access the platform again.',
      userSuspended: 'User Suspended',
      userSuspendedDescription: 'has been suspended.',
      userActivated: 'User Activated',
      userActivatedDescription: 'has been activated.',
      failedToSuspend: 'Failed to suspend user. Please try again.',
      failedToActivate: 'Failed to activate user. Please try again.',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      suspended: 'Suspended',
      name: 'Name',
      email: 'Email',
      location: 'Location',
      mentorshipType: 'Mentorship Type',
      pricePerSession: 'Price/Session',
      applied: 'Applied',
      files: 'Files',
      actions: 'Actions',
      review: 'Review',
      joined: 'Joined',
      viewDetails: 'View Details',
      mentorApplication: 'Mentor Application',
      personalInformation: 'Personal Information',
      mentorshipDetails: 'Mentorship Details',
      estimatedPricePerSession: 'Estimated Price Per Session',
      maxOneOnOneSessionsYear: 'Max 1:1 Sessions/Year',
      maxGroupSessionsYear: 'Max Group Sessions/Year',
      preferredSessionDuration: 'Preferred Session Duration',
      formalTraining: 'Formal Training',
      mentoringSkills: 'Mentoring Skills',
      motivation: 'Motivation',
      currentStatus: 'Current Status',
      idDocument: 'ID Document',
      downloadIdDocument: 'Download ID Document',
      close: 'Close',
      approve: 'Approve',
      reject: 'Reject',
      applicationApproved: 'Application Approved',
      applicationApprovedDescription: 'has been approved as a mentor.',
      applicationRejected: 'Application Rejected',
      applicationRejectedDescription: "'s application has been rejected.",
      error: 'Error',
      failedToApprove: 'Failed to approve application. Please try again.',
      failedToReject: 'Failed to reject application. Please try again.',
      downloadFailed: 'Download Failed',
      downloadFailedDescription:
        'Could not download the file. Please try again.',
      suspendAccount: 'Suspend Account',
      accountSuspended: 'Account Suspended',
      accountSuspendedDescription:
        'The user account has been suspended successfully.',
      failedToSuspendAccount:
        'Failed to suspend the account. Please try again.',
      meetingRoomTest: 'Meeting Room Test',
      meetingRoomTestDescription:
        'Create a temporary Jitsi room to validate the video call experience from the admin area.',
      meetingRoomTestSubjectPlaceholder: 'Admin Jitsi video call test',
    },
  },
  common: {
    seeAll: 'See All',
    publicRoute: {
      whoWeAre: (
        <>
          <strong>The Black Women in Tech Hub</strong> (BWTH) is a pioneering
          platform committed to addressing the current under-presentation of
          Black Women in the Technology sector and equip them for the growing
          digital economy
        </>
      ),
      newUser: 'New User?',
      createAccount: 'Create Account',
    },
    comingSoon: 'Coming Soon',
    stayTuned: 'We are working hard to build something great. Stay tuned!',
    noResultsYet: "There's No Results Here Yet",
    areYouSure: 'Are You Sure?',
    noResultsWereFound: 'No Results Were Found',
    somethingWentWrong: 'Something Went Wrong',
    userNotFound: 'The user could not be found.',
    userNotFoundDescription:
      'The user does not exists or has been suspended. Although you could login, you will not be able to access any data related to this user. If you think that this is a mistake, please contact our support team via email: info@bwbntechhub.com',
    yourSessionMightHaveExpired:
      'Your session might have expired. You can try refreshing the page or logging in again.',
    cancel: 'Cancel',
    continue: 'Continue',
    delete: 'Delete',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    requestConnection: 'Request Connection',
    viewProfile: 'View Profile',
    cancelConnectionRequest: 'Cancel Connection Request',
    acceptConnectionRequest: 'Accept Connection Request',
    cancelRequest: 'Cancel Request',
    addANoteToYourConnectionRequest: 'Add a Note To Your Connection Request?',
    sendConnectionRequest: 'Send Connection Request',
    addANoteFor: 'Add a Note For',
    connectionRequestHasBeenSent: 'Your Connection Request Has Been Sent',
    connectionRequestError: 'We had a problem while sending your request',
    removeConnectionRequestContentDialog:
      'Are you sure you want to remove this connection request? You can always send a new one later.',
    removeConnectionContentDialog:
      'Are you sure you want to remove this connection? You can always send a new one later.',
    connectionRequestHasBeenCancelled:
      'Your Connection Request Has Been Cancelled',
    theConnectionRequestHasBeenCancelled:
      'The Connection Request Has Been Cancelled',
    connectionRequestHasBeenAccepted:
      'The Connection Request Has Been Accepted',
    removeConnection: 'Remove Connection',
    addANote: 'Add a Note',
    backToPreviousPage: 'Back to Previous Page',
    notFound: 'Not Found',
    youSentThisConnectionRequest: 'You sent this connection request.',
    pricesAreInUSDollars: 'Prices are in U.S. dollars',
    usd: 'USD',
    form: {
      your: 'Your',
      userName: 'Username',
      emailAddress: 'Email Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      signIn: 'Sign In',
      signingIn: 'Signing In...',
      signUp: 'Sign Up',
      signingUp: 'Signing Up...',
      logOut: 'Log Out',
      loggingOut: 'Logging Out...',
      createProfile: 'Create Profile',
      creatingProfile: 'Creating Profile...',
      or: 'or',
      signInWithGoogle: 'Sign in with Google',
      selectMentorshipFocus: 'Select Mentorship Focus',
      firstName: 'First Name',
      lastName: 'Last Name',
      city: 'City',
      province: 'Province',
      selectAProvince: 'Select a Province',
      state: 'State',
      selectAState: 'Select a State',
      country: 'Country',
      paymentType: 'Payment Type',
      card: 'Card',
      paypal: 'Paypal',
      cardNumber: 'Card Number',
      expiry: 'Expiry',
      nameOnTheCard: 'Name on the card',
      cvv: 'CVV',
      postal: 'Postal Code',
      previous: 'Previous',
      next: 'Next',
      accept: 'Accept',
      gender: 'Gender',
      race: 'Race',
      ageGroup: 'Age Group',
      newPassword: 'New Password',
      currentPassword: 'Current Password',
      verify: 'Verify',
      verifying: 'Verifying...',
      preferredTimezone: 'Preferred Timezone',
      selectATimezone: 'Select a Timezone',
      passwordInputDescription:
        'A secure password that is at least 8 characters long and includes a mix of character types: at least one lowercase letter, one uppercase letter, one number, and one special character (such as !, @, #, $, %, etc.)',
      linkedInUrl: 'LinkedIn Url',
      handleOnX: 'Handle on X',
      personalWebsite: 'Personal Website',
      minutes: 'Minutes',
      hour: 'Hour',
      hours: 'Hours',
      dragAndDrop: 'Drag & Drop',
      chooseFile: 'Choose File',
      uploadCV: 'Upload CV',
      youCan: 'You can',
      contactUs: 'Contact Us',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      photo: 'Photo',
      removeFile: 'Remove File',
      maxUploadSizeForAvatar: 'JPG or PNG. 500kb max',
      loadingFile: 'Loading file',
      search: 'Search',
      searching: 'Searching',
      lostYourPassword: 'Lost Your Password?',
      resetPassword: 'Reset Password',
    },
    header: {
      myProfile: 'My Profile',
      support: 'Support',
      updatePassword: 'Update Password',
    },
  },
  errorBoundary: {
    tryAgain: 'Try Again',
    unexpectedErrorDescription:
      'An unexpected error occurred. You can try again or return to the dashboard.',
    meetingRoomErrorDescription:
      'Your meeting room encountered an unexpected issue. You can try to rejoin or return to your dashboard.',
    rejoinMeeting: 'Rejoin Meeting',
    returnToDashboard: 'Return to Dashboard',
    failedToLoadMeetingData: 'Failed to load meeting data',
    errorId: 'Error ID:',
    globalErrorDescription:
      "We are temporarily experiencing issues with our servers. Our team has been notified and is actively working to resolve the problem. We apologize for any inconvenience this may cause and appreciate your patience as we work to get everything back up and running smoothly. If you have any urgent concerns, please don't hesitate to contact our support via: info@bwbntechhub.com",
  },
  email: {
    sourceName: 'Black Women Tech Hub',
    sentConnectionRequest: {
      sentYouAConnectionRequest: 'sent you a connection request',
    },
    loginToYourAccount: 'Login to your account',
    welcome: {
      subject: 'Welcome to Black Women Tech Hub!',
      getStarted: 'Get Started',
    },
    welcomeMentor: {
      subject: 'Welcome to Black Women Tech Hub - Application Received',
      viewApplication: 'View Your Application',
    },
  },
} as const;
